export const STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}

export const STATUS_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Enabled',
    'value' : STATUS.ENABLED
  },
  {
    'label' : 'Disabled',
    'value' : STATUS.DISABLED
  }
]

export const STOCK_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'In Stock',
    'value' : 'true'
  },
  {
    'label' : 'Out Of Stock',
    'value' : 'false'
  }
]

export const GENDER = {
  MALE   : 'male',
  FEMALE : 'female'
}

export const GENDER_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'FEMALE',
    'value' : GENDER.FEMALE
  },
  {
    'label' : 'MALE',
    'value' : GENDER.MALE
  }
]

export const PRODUCTABLE_TYPE = {
  SELLER_MARKET_PRODUCT : 'Seller::MarketProduct',
  SELLER_PRODUCT        : 'Seller::Product',
  MERCHANT_PRODUCT      : 'Merchant::Product',
  MERCHANDISER_PRODUCT  : 'Merchandiser::Product',
  SCRAPER_PRODUCT       : 'Scraper::Product'
}

export const PRODUCTABLE_TYPE_OPTIONS = [
  {
    'label' : 'ALL',
    'value' : ''
  },
  {
    'label' : 'SELLER_MARKET_PRODUCT',
    'value' : PRODUCTABLE_TYPE.SELLER_MARKET_PRODUCT
  },
  {
    'label' : 'SELLER_PRODUCT',
    'value' : PRODUCTABLE_TYPE.SELLER_PRODUCT
  },
  {
    'label' : 'MERCHANT_PRODUCT',
    'value' : PRODUCTABLE_TYPE.MERCHANT_PRODUCT
  },
  {
    'label' : 'MERCHANDISER_PRODUCT',
    'value' : PRODUCTABLE_TYPE.MERCHANDISER_PRODUCT
  },
  {
    'label' : 'SCRAPER_PRODUCT',
    'value' : PRODUCTABLE_TYPE.SCRAPER_PRODUCT
  }
]

export const PER_PAGE_OPTIONS = [
  {
    'label' : '10',
    'value' : '10'
  },
  {
    'label' : '25',
    'value' : '25'
  },
  {
    'label' : '50',
    'value' : '50'
  },
  {
    'label' : '100',
    'value' : '100'
  }
]

export const SORT_OPTIONS = [
  {
    'id'       : 1,
    'label'    : 'Terbaru',
    'sort_by'  : 'live_date',
    'sort_dir' : 'desc'
  },
  {
    'id'       : 2,
    'label'    : 'Terlama',
    'sort_by'  : 'live_date',
    'sort_dir' : 'asc'
  },
  {
    'id'       : 3,
    'label'    : 'Termahal',
    'sort_by'  : 'selling_price',
    'sort_dir' : 'desc'
  },
  {
    'id'       : 4,
    'label'    : 'Termurah',
    'sort_by'  : 'selling_price',
    'sort_dir' : 'asc'
  }
]
